module.exports = __webpack_public_path__ + "app-static/img/icon_dingtou.02059c4e.png";